export default __webpack_public_path__ + "static/media/quizoraa.3820d520.png";